module.exports = __webpack_public_path__ + "img/space.1c9acaed.jpg";